import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "QuestionaryCurrencyRange" }
const _hoisted_2 = { class: "QuestionaryCurrencyRange-fieldWrapper" }
const _hoisted_3 = { class: "QuestionaryCurrencyRange-label" }
const _hoisted_4 = { class: "QuestionaryCurrencyRange-fieldWrapper QuestionaryCurrencyRange-fieldWrapper--two" }
const _hoisted_5 = { class: "QuestionaryCurrencyRange-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PxMoney = _resolveComponent("PxMoney")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t("common.from")), 1),
      _createVNode(_component_PxMoney, {
        modelValue: _ctx.values.min,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.values.min) = $event))
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("common.to")), 1),
      _createVNode(_component_PxMoney, {
        modelValue: _ctx.values.max,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.values.max) = $event))
      }, null, 8, ["modelValue"])
    ])
  ]))
}